import { ValueGetterParams } from "ag-grid-community";
import { Schedule } from "../../../../../../../services/cloudchipr.api";

export const workflowServiceValueGetter = ({
  data,
}: ValueGetterParams<Schedule>) =>
  data?.filter?.map((fil) => fil.filter.type).join(" ");
